<template>
	<div class="com-upload-file-wrap">
		<!-- 上传图片 -->
		<template v-if="type != 4">
			<div class="upload-file-wrap rela" :class="{'w100':showType==2 && !multiple}">
					<!-- :with-credentials='true' -->
				<el-upload 
					ref="commonUpload" 
					v-show="!upload.showImgView" 
					:data="upload.pam" 
					:action="ossSignature.host" 
					:class="{'avatar-uploader':showType==2&&!showFileList,'upload-demo':showFileList}"
					:multiple="multiple" 
					:limit="limit" 
					:show-file-list="showFileList&&showType!=2 ||showType==2&&multiple&&showFileList"
					:list-type="listType" 
					:file-list="fileList" 
					:drag="showType==3" 
					:disabled="disabled" 
					:on-exceed="overLimit"
					:before-upload="beforeUpload" 
					:on-remove="removeFileList" 
					:on-progress="uploadProcess" 
					:on-success="successUpload"
					:on-error="uploadError" 
					:on-preview="clickPreview">
					<template v-if="showType==1">
					  <el-button size="small" type="primary">{{ buttonName }}</el-button>
					  <div slot="tip" class="el-upload__tip">{{tipName}}</div>
					</template>
					<template v-if="showType==2">
						<div v-if="!upload.showProgress || multiple" :class="showFileList&&showType==2?'avatar-uploader':''">
							<i class="el-icon-plus"></i>
						</div>
						<el-progress v-if="upload.showProgress && !multiple" type="circle" :width="100" :stroke-width="3" :percentage="upload.uploadPercent"></el-progress>
					</template>
					<template v-if="showType==3">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">{{ dragTip }}</div>
					</template>
					
				</el-upload>

				<div @mouseover="upload.showDelImgIcon=true" @mouseout="upload.showDelImgIcon=false" class="show-img-wrap" v-if="upload.showImgView">
					<img :src="upload.uploadUrl.location?upload.uploadUrl.location:url" width="100" height="100">
					<i class="iconfont icon-jian-yuankuang i-delete abs" v-show="upload.showDelImgIcon" @click="delViewImg"></i>
				</div>
			</div>
		</template>
		<!-- 上传视频 -->
		<template v-if="type == 4">
			<div class="upload-file-wrap rela" :class="{'w100':showType==2 && !multiple}">
				<el-upload 
					ref="commonUpload" 
					v-show="!upload.showImgView" 
					action=""
					:class="{'avatar-uploader':showType==2&&!showFileList,'upload-demo':showFileList}"
					:multiple="multiple" 
					:limit="limit" 
					:show-file-list="showFileList&&showType!=2 ||showType==2&&multiple&&showFileList"
					:list-type="listType" 
					:file-list="fileList" 
					:drag="showType==3" 
					:disabled="uploadVideoInfo.uploadDisabled" 
					:on-exceed="overLimit"
					:before-upload="beforeUpload" 
					:on-remove="removeFileList" 
					:on-progress="uploadProcess" 
					:on-success="successUpload"
					:on-error="uploadError" 
					:on-preview="clickPreview"
					:http-request="uploadVideo">
					<el-button size="small" type="primary" v-if="showType==1">{{ buttonName }}</el-button>
					<template v-if="showType==2">
						<div v-if="!uploadVideoInfo.showProgress || multiple" :class="showFileList&&showType==2?'avatar-uploader':''">
							<i class="iconfont icon-iconset0481 i-play" v-if="!upload.showProgress"></i>
						</div>
						<el-progress v-if="uploadVideoInfo.showProgress && !multiple" type="circle" :width="100" :stroke-width="3" :percentage="uploadVideoInfo.uploadPercent"></el-progress>
					</template>
					<template v-if="showType==3">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">{{ dragTip }}</div>
					</template>
				</el-upload>
				<!-- <div @mouseover="uploadVideoInfo.showDelImgIcon=true" @mouseout="uploadVideoInfo.showDelImgIcon=false" class="show-img-wrap" v-if="uploadVideoInfo.showImgView">
					<img :src="upload.uploadUrl.location?upload.uploadUrl.location:url" width="100" height="100">
					<i class="iconfont icon-jian-yuankuang i-delete abs" v-show="upload.showDelImgIcon" @click="delViewImg"></i>
				</div> -->
			</div>
		</template>
	</div>
</template>

<script>
	import x2js from 'x2js'
	import {
		commonApi
	} from '@/api/common'
	export default {
		data() {
			return {
				//上传图片相关
				upload: {
					//上传阿里云相关参数
					pam: {
						success_action_status: '201',
						OSSAccessKeyId: '',
						policy: '',
						Signature: '',
						key: '',
					},
					//上传成功之后的路径
					uploadUrl: {
						key: '',
						location: '',
					},
					showProgress: false, //显示上传进度
					uploadPercent: 0, //上传百分比
					showImgView: false, //显示图片预览
					showDelImgIcon: false, //显示删除图片icon
				},
				ossSignature: {
					host: '', //上传阿里云服务器地址
					dir: '', //上传阿里云根目录
				},
				//上传视频相关
				uploadVideoInfo:{
					userId:'218043137435139574',//阿里账号ID
					region: 'cn-shanghai',//上传区域，默认为上海
					file: '', //视频文件
					uploader: '',//阿里上传组件
					showProgress: false, //显示上传进度
					uploadPercent: 0, //上传百分比
					uploadDisabled:false,//禁止上传
				},
				isOver:false
			}
		},
		props: {
			//上传类型控制，1为图片，2为私密文件，3为其他文件，4为视频。默认为图片
			type: {
				type: Number,
				default () {
					return 1
				}
			},
			//显示类型，1为按钮上传，2为图标上传，3为拖拽上传
			showType: {
				type: Number,
				default () {
					return 1
				}
			},
			buttonName: {
				type: String,
				default () {
					return '点击上传'
				}
			},
			tipName :{
				type: String,
				default () {
					return ''
				}
			},
			//拖拽上传提示语
			dragTip: {
				type: String,
				default () {
					return ''
				}
			},
			//图片上传成功之后是否显示预览图
			showImgView: {
				type: Boolean,
				default () {
					return true
				}
			},
			url: {
				type: String,
				default () {
					return ''
				}
			},
			//图片是否批量上传，默认不是
			multiple: {
				type: Boolean,
				default () {
					return false
				}
			},
			//批量上传时限制个数
			limit: {
				type: Number,
				default () {
					return 0
				}
			},
			imageUrl: {
				type: String,
				default () {
					return ''
				}
			},
			//是否限制上传文件大小，默认不限制
			limitSize: {
				type: Boolean,
				default () {
					return false
				}
			},
			limitWH:{
				type: Number,
				default () {
					return 0
				}
			},
			//限制上传文件大小
			limitSizeValue: {
				type: Number,
				default () {
					return 0
				}
			},
			//是否显示文件缩略图
			showFileList: {
				type: Boolean,
				default () {
					return false
				}
			},
			//缩略图类型
			listType: {
				type: String,
				default () {
					return ''
				}
			},
			//文件列表
			fileList: {
				type: Array,
				default () {
					return []
				}
			},
			//上传主键
			id: {
				type: Number,
				default () {
					return 0
				}
			},
			//文件上传路径名
			filePath: {
				type: String,
				default () {
					return 'upload/commonfile'
				}
			},
			//是否禁用
			disabled: {
				type: Boolean,
				default () {
					return false
				}
			}
		},
		mounted() {
			this.getOssSignature()
			this.judgeShowImg()
		},
		methods: {
			judgeShowImg() {
				if ((this.type == 1) && this.url != '') {
					this.upload.showImgView = true
				}
			},
			getOssSignature() {
				if(this.type == 4){
					return false
				}
				var pam = {
					type: this.type,
				}
				this.$EpetJs.Common.get(commonApi.getOssSignatureUrl,pam).then(res=>{
					if(res.data.status_code == this.$EpetJs.Const.successStatus){
						this.upload.pam.OSSAccessKeyId = res.data.data.accessid
						this.upload.pam.policy = res.data.data.policy
						this.upload.pam.Signature = res.data.data.signature
						this.ossSignature.host = res.data.data.host
						this.ossSignature.dir = res.data.data.dir
					}else{
						this.$message.warning(res.data.message)
					}
				})
			},
			//文件个数超出限制
			overLimit() {
				if (this.multiple && this.limit) {
					this.$message.warning('上传文件个数超出限制！最多允许上传' + this.limit + '个')
				}
			},
			//开始上传前
			beforeUpload(file) {
				//判断上传文件格式
				switch(this.type){
					case 1:
						if (file.type.indexOf('image') < 0) {
							this.$message.warning('图片格式不正确！')
							return false
						}
						break
					case 4:
						if (file.type.indexOf('video') < 0) {
							this.$message.warning('视频格式不正确！')
							return false
						}
						break
				}
				//判断是否超出大小限制
				if (this.limitSize) {
					let size = this.limitSizeValue ? this.limitSizeValue : 1048576
					if (file.size > size) {
						this.$message.warning('上传文件大小不能超过' + Number(size) / 1024 / 1024 + 'M！')
						return false
					}
				}
				//限制图片宽高
				if(this.limitWH){
					let that =this
					new Promise(function(resolve, reject) {
                            let width = that.limitWH;
                            let height =179;
                            let _URL = window.URL || window.webkitURL;
                            let img = new Image();
                            img.src = _URL.createObjectURL(file);
							
                            img.onload = function() {
                                let valid = img.width == width && img.height == height;
                                 valid ? resolve() : reject();
                            }
                    }).then(() => {
							this.isOver=false;
                            return file;
                    }, () => {
							this.isOver=true;
                            this.$message.error('上传的图片宽高必须是'+that.limitWH+'*179');
                            return Promise.reject();
                    });
				}
				

				let suffix = ''
				const month = new Date().getMonth() > 10 ? JSON.stringify(new Date().getMonth() + 1) : '0' + JSON.stringify(new Date()
					.getMonth() + 1)
				const day = new Date().getDate() > 10 ? JSON.stringify(new Date().getDate()) : '0' + JSON.stringify(new Date().getDate())
				const h = new Date().getHours() > 10 ? JSON.stringify(new Date().getHours()) : '0' + JSON.stringify(new Date().getHours())
				const m = new Date().getMinutes() > 10 ? JSON.stringify(new Date().getMinutes()) : '0' + JSON.stringify(new Date().getMinutes())
				const s = new Date().getSeconds() > 10 ? JSON.stringify(new Date().getSeconds()) : '0' + JSON.stringify(new Date().getSeconds())
				let randomName = `${JSON.stringify(new Date().getFullYear())}/${month}/${day}/` + h + m + s +'_' +JSON.stringify(Math.floor(
					Math.random() * (999999 - 100000)))
				if (file.name.lastIndexOf('.') != -1) {
					suffix = file.name.substring(file.name.lastIndexOf('.'))
				}
				//获取图片宽高
				let img = new Image()
				let _URL = window.URL || window.webkitURL
				img.onload = function() {
					file.width = img.width
					file.height = img.height
				}
				img.src = _URL.createObjectURL(file)
				this.upload.pam.key = this.ossSignature.dir + this.filePath + '/' + randomName + suffix
				this.$emit('getFile', file)
			},
			//上传过程
			uploadProcess(event, file, fileList) {
				this.upload.showProgress = true
				this.upload.uploadPercent = parseInt(file.percentage.toFixed(0))
				let xToJson = new x2js()
				fileList.forEach(v => {
					let fileRes = xToJson.xml2js(v.response)
					if (fileRes) {
						this.$set(v, 'response', {
							Key: fileRes.PostResponse.Key,
							Location: fileRes.PostResponse.Location,
							Bucket: fileRes.PostResponse.Bucket
						})
					}
				});
				this.$emit('progress', {
					id: this.id,
					file: file,
					filelist: fileList
				})
			},
			//成功上传
			async successUpload(response, file, fileList) {
				// const duration = this.type == 2?Math.floor(await this.getDuration(response)):0
				const duration = 0
				this.upload.showProgress = false
				let xToJson = new x2js()
				let res = xToJson.xml2js(response)
				this.upload.uploadUrl.key = res.PostResponse.Key
				this.upload.uploadUrl.location = res.PostResponse.Location
				if (this.showType == 2 && this.showImgView && !this.multiple) {
					this.upload.showImgView = true
				}
				fileList.forEach(v => {
					let fileRes = xToJson.xml2js(v.response)
					if (fileRes) {
						this.$set(v, 'response', {
							Key: fileRes.PostResponse.Key,
							Location: fileRes.PostResponse.Location,
							Bucket: fileRes.PostResponse.Bucket
						})
					}
				});
				console.log(this.isOver)
				if(this.isOver){
					res.PostResponse.Location=''	
				}
				this.$emit('success', {
					'id': this.id,
					'file': file,
					'fileList': fileList,
					'Key': res.PostResponse.Key,
					'Location': res.PostResponse.Location,
					'Bucket': res.PostResponse.Bucket,
					'Duration': duration,
					'Size': file.size
				})
			},
			//上传失败
			uploadError() {
				this.$message.error('上传失败')
				this.upload.showProgress = false
				this.upload.uploadPercent = 0
			},
			//移除上传列表
			removeFileList(file, fileList) {
				file.id = this.id
				let xToJson = new x2js()
				fileList.forEach(v => {
					let fileRes = xToJson.xml2js(v.response)
					if (fileRes) {
						this.$set(v, 'response', {
							Key: fileRes.PostResponse.Key,
							Location: fileRes.PostResponse.Location,
							Bucket: fileRes.PostResponse.Bucket
						})
					}
				});
				this.$emit('remove', file, fileList)
			},
			//获取视频时长
			async getDuration(url) {
				const tempvideo = document.getElementById('tempvideo')
				const promise = new Promise(resolve => {
					if (tempvideo) {
						document.body.removeChild(tempvideo)
					}
					const video = document.createElement('video')
					video.src = url
					video.id = 'tempvideo'
					video.style.display = 'none'
					document.body.appendChild(video)
					video.addEventListener('canplaythrough', e => {
						if (e.target.duration) {
							resolve(e.target.duration)
						} else {
							resolve(0)
						}
					})
				})
				return promise
			},
			//删除预览图片
			delViewImg() {
				this.upload.showImgView = false
				if (this.upload.uploadUrl.location === '' && this.url) {
					this.$emit('del')
				}
			},
			//点击预览图片
			clickPreview(file) {
				this.$emit('preview', {
					'id': this.id,
					'file': file,
				})
			},
			//清空文件
			clearFiles() {
				this.$refs.commonUpload.clearFiles()
			},
			//上传视频
			uploadVideo(file){
				var Title = file,name
				var userData = '{"Vod":{}}'
				if (this.uploadVideoInfo.uploader) {
					this.uploadVideoInfo.uploader.stopUpload()
				}
				this.uploadVideoInfo.uploader = this.createUploader()
				this.uploadVideoInfo.uploader.addFile(file.file, null, null, null, userData)
				this.uploadVideoInfo.uploadDisabled = true
			},
			//初始化视频上传
			createUploader(type) {
				let self = this
				let uploader = new AliyunUpload.Vod({
					timeout: self.timeout || 60000,
					partSize: self.partSize || 1048576,
					parallel: self.parallel || 5,
					retryCount: self.retryCount || 3,
					retryDuration: self.retryDuration || 2,
					region: self.uploadVideoInfo.region,
					userId: self.uploadVideoInfo.userId,
					// 添加文件成功
					addFileSuccess: function(uploadInfo) {
						uploader.startUpload()
					},
					// 开始上传
					onUploadstarted: function(uploadInfo) {
						// 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
						// 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
						// 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
						// 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
						// 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
						// 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
						if (!uploadInfo.videoId) {
							self.$EpetJs.Common.ajax('get',commonApi.getOssVideoAuthUrl,{
								title:uploadInfo.file.name,
								file_name:uploadInfo.file.name
							}).then(res=>{
								if(res){
									let uploadAuth = res.data.data.UploadAuth
									let uploadAddress = res.data.data.UploadAddress
									let videoId = res.data.data.VideoId
									uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
								}
							})
						} else {
							// 如果videoId有值，根据videoId刷新上传凭证
							// https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
							self.$EpetJs.Common.ajax('get',commonApi.refreshVideoAuthUrl,{
								video_id:uploadInfo.videoId
							}).then(res=>{
								if(res){
									let uploadAuth = res.data.data.UploadAuth
									let uploadAddress = res.data.data.UploadAddress
									let videoId = res.data.data.VideoId
									uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
								}
							})
						}
					},
					// 文件上传成功
					onUploadSucceed: function(uploadInfo) {
						self.getDuration('https://'+uploadInfo.bucket+'.oss-'+uploadInfo.region+'.aliyuncs.com/'+uploadInfo.object).then(data=>{
								self.$emit('success', {
									'id': self.id,
									'file': uploadInfo.file,
									'Key': uploadInfo.object,
									'Location': 'https://'+uploadInfo.bucket+'.oss-'+uploadInfo.region+'.aliyuncs.com/'+uploadInfo.object,
									'Bucket': uploadInfo.bucket,
									'Duration': Math.floor(data),
									'Size': uploadInfo.file.size
								})
						})
						self.uploadVideoInfo.uploadDisabled = false
						self.uploadVideoInfo.showProgress = false
						self.uploadVideoInfo.uploadPercent = 0
					},
					// 文件上传失败
					onUploadFailed: function(uploadInfo, code, message) {
						self.$message.error('上传失败')
						self.uploadVideoInfo.showProgress = false
						self.uploadVideoInfo.uploadPercent = 0
						self.uploadVideoInfo.uploadDisabled = false
					},
					// 取消文件上传
					onUploadCanceled: function(uploadInfo, code, message) {
						self.$message.warning('文件已暂停上传')
						self.uploadVideoInfo.uploadDisabled = false
					},
					// 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
					onUploadProgress: function(uploadInfo, totalSize, progress) {
						let progressPercent = Math.ceil(progress * 100)
						self.uploadVideoInfo.showProgress = true
						self.uploadVideoInfo.uploadPercent = progressPercent
						self.$emit('progress', {
							id: self.id,
							file: uploadInfo.file,
							fileSize:totalSize,
							percent:Math.ceil(progress * 100)
						})
					},
					// 上传凭证超时
					onUploadTokenExpired: function(uploadInfo) {
						// 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
						// 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth					
						self.$EpetJs.Common.ajax('get',commonApi.refreshVideoAuthUrl,{
							video_id:uploadInfo.videoId
						}).then(res=>{
							if(res){
								let uploadAuth = res.data.data.UploadAuth
								uploader.resumeUploadWithAuth(uploadAuth)
							}
						})
					},
					// 全部文件上传结束
					onUploadEnd: function(uploadInfo) {
						self.uploadVideoInfo.uploadDisabled = false
					}
				})
				return uploader
			}
		},
		watch: {
			url() {
				this.judgeShowImg()
			}
		}
	}
</script>

<style lang="less">
	.com-upload-file-wrap {
		.avatar-uploader {
			width: 100px;
			height: 100px;
			display: inline-block;
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;

			.el-icon-plus {
				font-size: 40px;
				color: #8c939d;
				width: 100px;
				height: 100px;
				line-height: 100px;
				text-align: center;
			}

			.i-play {
				display: inline-block;
				font-size: 45px;
				color: #8c939d;
				width: 100px;
				height: 100px;
				line-height: 100px;
				text-align: center;
			}

			.i-delete {
				right: -2px;
				top: -6px;
				font-size: 20px;
				cursor: pointer;
				color: red;
			}

			.el-progress {
				position: absolute;
				left: 0;
				top: 0;
				width: 100px;
				height: 100px;
			}
		}

		.upload-demo {
			width: 360px;

			.el-progress {
				position: absolute;
				left: 0;
				top: 0;
				width: 100px;
				height: 100px;
			}
		}

		.upload-file-wrap {
			display: inline-block;
			margin: 0 10px 10px 0;

			.show-img-wrap {
				width: 100px;
				height: 100px;

				img {
					border: 1px dashed #d9d9d9;
					border-radius: 5px;
				}

				.i-delete {
					right: -2px;
					top: -12px;
					font-size: 20px;
					cursor: pointer;
					color: red;
				}
			}
		}

		.el-upload-list--picture .el-upload-list__item {
			width: 100px !important;
			float: left;
			margin-right: 10px;
		}

		.w100 {
			width: 100px;
			height: 100px;
		}
	}
</style>
